<template>
  <div class="zhaoping-testbasis-subsection" v-anim="'animate__fadeInUp'" style="animation-delay:0.2s">

    <img class="mask-group-3" alt="Mask group" src="/static/img/zhaoping-mask-group-21.jpg" loading="lazy" />

  </div>
</template>

<script>
export default {
  name: "ZhaopingTestBasisSubsection",
  directives: {
    anim: {
      inserted(el, binding) {
        const cls = binding && binding.value ? binding.value : "animate__fadeInUp";
        el.classList.add("animate__animated");
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                el.classList.add(cls);
                io.unobserve(el);
              }
            });
          },
          { threshold: 0.2 }
        );
        io.observe(el);
      },
    },
  },
};
</script>

<style scoped>
.zhaoping-testbasis-subsection { position: absolute; top: 3004px; left: -350px; width: 813px; height: 473px; }
.rectangle-11 { background-color: #e1e1e1; border-radius: 15px; height: 473px; left: 0; position: absolute; top: 0; width: 813px; }
.mask-group-3 { height: 473px; left: 360px; position: absolute; top: 0; width: 453px; }
.text-wrapper-14 { align-items: center; color: #000000; display: flex; font-family: "PingFang SC-Regular", Helvetica; font-size: 24px; font-weight: 400; height: 30px; justify-content: center; left: 43px; letter-spacing: 0; line-height: 30px; position: absolute; top: 276px; width: 220px; }
</style>
